const getLoginRequest = userInfo => {
    const { username, password, role } = userInfo;
    return {
        username,
        password,
        role
    };
};

export default getLoginRequest;
